import script from "./CouponsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponsPage.vue?vue&type=script&setup=true&lang=js"

import "./CouponsPage.vue?vue&type=style&index=0&id=4f689fd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f689fd6"]])

export default __exports__